// extracted by mini-css-extract-plugin
export default {"table":"compact-table_table__yhyZp"};